module.exports = __webpack_public_path__ + "img/support.6418d586.svg";